import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';

export const ProductItem = (props) => {
	const { title, text, image, link } = props;
	return (
		<Col className="service-item-two" md={4} sm={6} xs={12}>
			<div className="inner-box wow fadeInDown" {...props}>
				<figure className="icon-box">
					<img src={require('../../../assets/images/products')[image]} alt={title} />
				</figure>
				<h3><Link to={link}>{title}</Link></h3>
				<div className="text">{text}</div>
				<div className="more-btn"><Link to={link} className="theme-btn">
					<span className="flaticon-arrows" /></Link>
				</div>
			</div>
		</Col>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Products/ProductItem.js